import { Component, OnDestroy, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { AppShieldEventLogsComponent, ShieldApiStore } from '@bn/app-shield';
import { PlanType } from '@bn/app-shield/enums';
import { AppRoutes } from '@bn/dashboard-core/enums';
import { ContentService } from '@bn/shared/services';

@Component({
  templateUrl: './app-shield-event-log.page.html',
  styleUrls: ['./app-shield-event-log.page.scss'],
  imports: [AppShieldEventLogsComponent],
})
export class AppShieldEventLogPage implements OnDestroy {
  readonly #shieldStore = inject(ShieldApiStore);
  readonly selectedShield = this.#shieldStore.selectedEntity();

  public readonly contentService = inject(ContentService);

  constructor() {
    const pullZoneId = this.#shieldStore.pullZoneId();

    this.contentService.setTitle('Event logs');
    this.contentService.setBackButton({
      routerLink: `/${AppRoutes.CDN}/${pullZoneId}/${AppRoutes.Shield}`,
    });

    this.subscribeToStoreSignals();
  }

  public ngOnDestroy(): void {
    this.contentService.setBackButton(null);
    this.contentService.setBadge(null);
  }

  private subscribeToStoreSignals(): void {
    toObservable(this.selectedShield)
      .pipe(filter((shield) => !!shield))
      .pipe(takeUntilDestroyed())
      .subscribe((shield) => {
        const plan = shield?.planType || 0;

        if (plan > PlanType.Basic) {
          const planName = PlanType[plan];

          this.contentService.setBadge({
            contextType: 'premium',
            text: planName,
            tooltip: `You have Bunny Shield ${planName} enabled`,
          });
        } else {
          this.contentService.setBadge(null);
        }
      });
  }
}
